exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js
// module id = 172
// module chunks = 0